import { createFileRoute } from "@tanstack/react-router";
import FounderWeekModule from "@/pages/FounderWeekModule";

export const Route = createFileRoute("/accelerator/week/$weekNumber/")({
  component: FounderWeekModule,
});
